import Tooltip from '@mui/material/Tooltip';
import Hr from '__core/modules/atoms/Hr';
import Icon from '__core/modules/atoms/Icons';
import clsx from 'clsx';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const ListSimpleDropdown = ({ items = [], onClick, preventEvent, sizeIcon = 'small' }) => {
  const delay = 600;

  function getColor(item) {
    const color = item.color && item.colorIcon;
    return item.disabled ? 'inherit' : color;
  }

  function getOnClick(item, event) {
    if (preventEvent) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (item.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return null;
    }

    return onClick ? onClick(item, event) : item.onClick(item, event);
  }

  function _renderItem(item) {
    return (
      <div className="list-simple-dropdown__texts">
        <span className={clsx('list-simple-dropdown__name', { disabled: item.disabled })} data-testid={item.icon || item.name}>
          {item.name}
        </span>
        <span className="list-simple-dropdown__description">{item.description} </span>
      </div>
    );
  }

  return (
    <ul className="list-simple-dropdown">
      {items.map((item) => (
        <Fragment key={item.key || item.name || uniqueId()}>
          {item.id === 'separator' && <Hr size="small" />}

          {item.id !== 'separator' && (
            <button
              type="button"
              className={clsx(
                'list-simple-dropdown__li',
                {
                  'list-simple-dropdown__li--active': item.active,
                  'list-simple-dropdown__li--disabled': item.disabled,
                },
                item.className
              )}
              key={item.name}
              onClick={(event) => getOnClick(item, event)}
              aria-haspopup={item.ariaHasPopup}
              aria-expanded={item.ariaHasPopup ? !!item.ariaExpanded : undefined}
            >
              {item.dot && <span className="list-simple-dropdown__dot" style={{ backgroundColor: item.dot }} aria-hidden="true" />}

              {item.icon && (
                <div className="list-simple-dropdown__icon">
                  <Icon type={item.icon} color={getColor(item)} fontSize={sizeIcon} />
                </div>
              )}

              {item.tooltip ? (
                <Tooltip classes={{ tooltip: 'list-simple-dropdown__tooltip' }} title={item.tooltip} enterDelay={delay} enterNextDelay={delay}>
                  {_renderItem(item)}
                </Tooltip>
              ) : (
                _renderItem(item)
              )}

              {item.rightIcon && (
                <div className="list-simple-dropdown__icon list-simple-dropdown__icon--right">
                  <Icon type={item.rightIcon} color={item.active ? 'action' : 'inherit'} fontSize={sizeIcon} />
                </div>
              )}
            </button>
          )}
        </Fragment>
      ))}
    </ul>
  );
};

ListSimpleDropdown.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      ariaExpanded: PropTypes.bool,
      ariaHasPopup: PropTypes.oneOf(['menu', 'listbox', 'tree', 'grid', 'dialog']),
      description: PropTypes.string,
      disabled: PropTypes.bool,
      dot: PropTypes.string,
      icon: PropTypes.string,
      id: PropTypes.oneOf(['', 'separator']),
      key: PropTypes.string,
      onClick: PropTypes.func,
      rightIcon: PropTypes.string,
      tooltip: PropTypes.string,
    })
  ),
  sizeIcon: PropTypes.oneOf(['inherit', 'large', 'medium', 'small']),
};

export default ListSimpleDropdown;
